import Modal from '@Components/Shared/Modals/Modal';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const EmailAlertsChangesSavedModal = (props) => {
    return (
        <Modal containerClassName='alert-modal'>
            <Modal.Header onClose={props.onClose}>
                <div className="top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        <TranslationText tKey='sandhills.success' />
                    </Modal.Title></div>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>Email Alert {props.message} Saved</p>
                <p>{props.message}</p>
                <input type='button' className='button ts-button' value={translator.translate('sandhills.tradesites.mvc.okay')} onClick={props.onClose} />
            </Modal.Body>
        </Modal>
    );
}

export default EmailAlertsChangesSavedModal;